"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _FiltersModule = _interopRequireDefault(require("../../styles/components/Filters.module.css"));
var _reactRedux = require("react-redux");
var _translations = require("../../entities/translations");
var _functions = require("../../utils/functions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ResetButton = _ref => {
  let {
    activeFilters,
    saveActiveFilters,
    theme
  } = _ref;
  const {
    [11]: resetAll
  } = (0, _reactRedux.useSelector)(_translations.selectActiveTranslationsInterfaceUILocalizations, _functions.areEqual);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_material.Button, {
    variant: "link",
    className: "".concat(_FiltersModule.default.reset_btn, " ").concat(_FiltersModule.default[theme], " ").concat(Object.keys(activeFilters).length ? '' : _FiltersModule.default.hide),
    onClick: () => saveActiveFilters({})
  }, resetAll !== null && resetAll !== void 0 ? resetAll : 'Reset all'), [activeFilters, saveActiveFilters, theme, resetAll]);
};
var _default = exports.default = ResetButton;